module.exports = __webpack_public_path__ + "img/require.80e85b7c.jpg";